<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .cta-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: utils.in_rem(4px);

    .cta-label {
      overflow: hidden;
      text-overflow: ellipsis;
      color: colors.get(textBlack);
      @include mixins.body4();
    }
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  // Components
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import Toggletip from "@sourcewhale/shared/svelte-design-system/components/atoms/Toggles/Toggletip.svelte";
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import MoreInfo from "./MoreInfo.svelte";
  import SendMessagePhoneList from "./SendMessagePhoneList.svelte";
  // Utils
  import { hasConversationsLicense } from "@sourcewhale/core";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "./context";

  // Get stores from context
  const { candidatePhoneStore, activePopUpModalStore } =
    getContext(CONTACT_CTAS_CONTEXT);

  let {
    kind = "secondary",
    size = "candidate-cta",
    leadingIcon = "",
    wrapper = true,
    style = "",
    tooltipPlacement = "top",
    dropdownPlacement = "bottom",
    children,
  } = $props();

  const smsButtonProps = $state({
    kind,
    size,
    leadingIcon,
    trailingIcon: "",
    style,
  });

  let closeDropdown = $state(null);
  const openModal = (number) => {
    if (closeDropdown) closeDropdown();

    activePopUpModalStore.set({ modal: "sendMessage", kind: "sms", number });
  };

  const moreInfoProps = () => {
    if (!$userStore.includeSms) {
      // TODO - link to help guide
      return {
        info: $userStore.isAdmin
          ? "Your team does not have SMS enabled. Please contact us to learn more."
          : "Your team does not have SMS enabled. Please contact your admin to enable it.",
      };
    }

    if ($userStore.isAdmin) {
      return {
        info: "You need to submit the SMS compliance form in the Admin Compliance tab to enable messaging.",
        buttonText: "Admin",
        href: "/admin#compliance",
      };
    }

    return {
      info: "Your admin needs to submit the SMS compliance form to enable messaging.",
    };
  };
</script>

{#snippet button()}
  {#if $candidatePhoneStore.length === 0 || !hasConversationsLicense($userStore)}
    <ButtonWithTooltip
      {...smsButtonProps}
      class="disabled"
      placement={tooltipPlacement}
    >
      <span slot="tooltip"
        >{hasConversationsLicense($userStore)
          ? "No phone numbers available."
          : "Sending SMS requires a Conversations license."}</span
      >
      {@render children?.()}
    </ButtonWithTooltip>
  {:else if !$userStore.hasSms || !$userStore.includeSms}
    <Toggletip placement={tooltipPlacement} let:toggle>
      <MoreInfo slot="toggletip" {...moreInfoProps()} />
      <Button {...smsButtonProps} placement={tooltipPlacement} onclick={toggle}>
        {@render children?.()}
      </Button>
    </Toggletip>
  {:else if $candidatePhoneStore.length === 1}
    {@const phoneObj = $candidatePhoneStore[0]}
    <ButtonWithTooltip
      {...smsButtonProps}
      placement={tooltipPlacement}
      onclick={() => openModal(phoneObj.phone)}
    >
      <span slot="tooltip">Send an SMS message to {phoneObj.phone}</span>
      {@render children?.()}
    </ButtonWithTooltip>
  {:else}
    <Dropdown
      {...smsButtonProps}
      placement={dropdownPlacement}
      {tooltipPlacement}
      dynamicWidth={false}
      bind:close={closeDropdown}
    >
      <span slot="button">
        {@render children?.()}
      </span>
      <span slot="tooltip">Send an SMS message</span>
      <SendMessagePhoneList kind="sms" onPhoneClick={openModal} />
    </Dropdown>
  {/if}
{/snippet}

{#if wrapper}
  <div class="cta-wrapper">
    {@render button()}
    <span class="cta-label">SMS</span>
  </div>
{:else}
  {@render button()}
{/if}
